<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Call Center</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Atención y seguimiento comercial que <span class="highlight-green">convierten</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Operación multicanal para mejorar respuesta, seguimiento y experiencia del cliente.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Atención al cliente multicanal</li>
          <li><i class="bi bi-check-circle-fill"></i> Gestión de pedidos, reservas y leads</li>
          <li><i class="bi bi-check-circle-fill"></i> Soporte especializado</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-telephone"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-headset"></i>
          </div>
          <h4 class="modern-service-card-title">Atención al Cliente</h4>
          <p>Ofrecemos atención personalizada, empática y orientada a resolver cada interacción.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-diagram-3"></i>
          </div>
          <h4 class="modern-service-card-title">Gestión CRM</h4>
          <p>Integramos herramientas para seguimiento, control de leads y optimización de flujos comerciales.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-bar-chart-line"></i>
          </div>
          <h4 class="modern-service-card-title">Análisis de Datos</h4>
          <p>Medimos indicadores clave para mejorar tiempos de respuesta, calidad y conversión.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Equipo entrenado y profesional</li>
          <li><i class="bi bi-check-circle-fill"></i> Tecnología para gestión eficiente</li>
          <li><i class="bi bi-check-circle-fill"></i> Flexibilidad y escalabilidad operativa</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Convierte cada contacto en una oportunidad mejor atendida.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
